import * as React from 'react';

interface IProps {
    id: string;
    className?: string;
    value: string
    disabled?: boolean;
    onChange: (event: any) => void;
    onBlur?: (event: any) => void;
    inputValid?: boolean;
    validationMessage?: string;
    maxLength?: number;
    minLength?: number;
}

export class TextInputWithoutLabel extends React.Component<IProps> {

    constructor(props: any) {
        super(props);
    }

    public render(): React.ReactNode {
        return (
            <div className="form-group mb-2">
                <div className="input-group">
                    <input
                        type="text"
                        className={this.props.className}
                        id={this.props.id}
                        value={this.props.value}
                        maxLength={this.props.maxLength}
                        minLength={this.props.minLength}
                        disabled={this.props.disabled}
                        onChange={this.props.onChange}
                        onBlur={this.props.onBlur}/>

                    {this.props.inputValid === false &&
                        <div className="invalid-feedback d-block">{this.props.validationMessage}</div>
                    }
                </div>
            </div>
        )
    }
}
